"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _reactRedux = require("react-redux");

var _DynoEditor = require("lead-flows-ui/constants/DynoEditor");

var _TopicClusters = require("lead-flows-ui/actions/TopicClusters");

var _TopicClusters2 = require("lead-flows-ui/selectors/TopicClusters");

var DynoEditorAudienceActions = _interopRequireWildcard(require("lead-flows-ui/actions/DynoEditorAudience"));

var _Filters = _interopRequireDefault(require("lead-flows-ui/constants/AudienceTargeting/Filters"));

var _AudienceTargetingTriggers = _interopRequireDefault(require("./AudienceTargetingTriggers"));

var _AudienceTargetingComponent = _interopRequireDefault(require("AudienceTargetingUIComponents/AudienceTargetingComponent"));

var _eventsTrackerUtils = require("lead-flows-ui/utils/eventsTrackerUtils");

var AudienceTargetingContainer =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(AudienceTargetingContainer, _Component);
  (0, _createClass2.default)(AudienceTargetingContainer, null, [{
    key: "propTypes",
    get: function get() {
      return {
        addDynoAudienceGroup: _react.PropTypes.func.isRequired,
        addHideGroup: _react.PropTypes.func.isRequired,
        addValidationError: _react.default.PropTypes.func.isRequired,
        audience: _react.default.PropTypes.object,
        clusters: _react.PropTypes.object,
        displayOnExitIntent: _react.PropTypes.bool.isRequired,
        displayOnScroll: _react.PropTypes.bool.isRequired,
        displayOnTimedDelay: _react.PropTypes.number.isRequired,
        filter: _react.PropTypes.object,
        removeDynoAudienceGroup: _react.PropTypes.func.isRequired,
        removeValidationError: _react.default.PropTypes.func.isRequired,
        requestTopicClusters: _react.PropTypes.func.isRequired,
        setDynoAudience: _react.PropTypes.func.isRequired,
        scopes: _react.PropTypes.array.isRequired,
        topicClustersRequestState: _react.PropTypes.object.isRequired,
        type: _react.PropTypes.string.isRequired,
        updateDyno: _react.PropTypes.func.isRequired,
        updateDynoAudienceGroup: _react.PropTypes.func.isRequired,
        validation: _react.PropTypes.object.isRequired,
        addFilter: _react.PropTypes.func.isRequired,
        removeFilter: _react.PropTypes.func.isRequired,
        updateFilter: _react.PropTypes.func.isRequired
      };
    }
  }]);

  function AudienceTargetingContainer(props) {
    var _this;

    (0, _classCallCheck2.default)(this, AudienceTargetingContainer);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(AudienceTargetingContainer).call(this, props));
    _this.handleChange = _this.handleChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleErrors = _this.handleErrors.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(AudienceTargetingContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var requestTopicClusters = this.props.requestTopicClusters;
      requestTopicClusters();
    }
  }, {
    key: "langKey",
    value: function langKey() {
      var suffix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return "leadFlowEditor.leadFlowOptionsEditor.targeting." + suffix;
    }
  }, {
    key: "clearErrors",
    value: function clearErrors() {
      var _this$props = this.props,
          validation = _this$props.validation,
          removeValidationError = _this$props.removeValidationError;
      Object.keys(validation).forEach(function (error) {
        return removeValidationError(error, _DynoEditor.STEPS.TARGETING);
      });
    }
  }, {
    key: "handleErrors",
    value: function handleErrors(errors) {
      var _this2 = this;

      var addValidationError = this.props.addValidationError;
      this.clearErrors();
      var normalizedErrors = errors.map(function (error) {
        var langKey = "error." + error[1];
        error[1] = "" + _this2.langKey(langKey);
        return error;
      });
      return normalizedErrors.forEach(function (error) {
        return addValidationError.apply(void 0, (0, _toConsumableArray2.default)(error));
      });
    }
  }, {
    key: "handleChange",
    value: function handleChange(audience) {
      var updateDyno = this.props.updateDyno;
      this.clearErrors();
      updateDyno({
        audience: audience
      });
    }
  }, {
    key: "renderTriggers",
    value: function renderTriggers() {
      var _this$props2 = this.props,
          type = _this$props2.type,
          displayOnExitIntent = _this$props2.displayOnExitIntent,
          displayOnScroll = _this$props2.displayOnScroll,
          displayOnTimedDelay = _this$props2.displayOnTimedDelay,
          validation = _this$props2.validation,
          updateDyno = _this$props2.updateDyno,
          addValidationError = _this$props2.addValidationError,
          removeValidationError = _this$props2.removeValidationError;
      return _react.default.createElement("div", null, _react.default.createElement(_AudienceTargetingTriggers.default, {
        type: type,
        displayOnExitIntent: displayOnExitIntent,
        displayOnScroll: displayOnScroll,
        displayOnTimedDelay: displayOnTimedDelay,
        validation: validation,
        updateDyno: updateDyno,
        addValidationError: addValidationError,
        removeValidationError: removeValidationError
      }));
    }
  }, {
    key: "renderAudienceTargeting",
    value: function renderAudienceTargeting() {
      var _this$props3 = this.props,
          audience = _this$props3.audience,
          scopes = _this$props3.scopes;
      var labelConfig = {
        explanation: _I18n.default.text(this.langKey('explanation')),
        behaviourExplanation: _I18n.default.text(this.langKey('behaviourExplanation')),
        websiteExplanation: _I18n.default.text(this.langKey('websiteExplanation')),
        websiteHelp: _I18n.default.text(this.langKey('websiteHelpIcon')),
        assetName: _I18n.default.text(this.langKey('assetName'))
      };
      return _react.default.createElement(_AudienceTargetingComponent.default, {
        filterList: Object.keys(_Filters.default),
        labelConfig: labelConfig,
        audience: audience,
        onChange: this.handleChange,
        onValidationError: this.handleErrors,
        scopes: scopes,
        upgradeConfig: {
          app: 'lead-flows-ui',
          screen: 'targeting',
          modalKey: 'audience-targeting-marketing-professional'
        },
        usageTracking: _eventsTrackerUtils.trackEditorInteraction
      });
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "dyno-editor-targeting-panel-group"
      }, this.renderAudienceTargeting(), this.renderTriggers());
    }
  }]);
  return AudienceTargetingContainer;
}(_react.Component);

function mapStateToProps(state) {
  return {
    clusters: (0, _TopicClusters2.getTopicClusters)(state),
    topicClustersRequestState: (0, _TopicClusters2.getTopicClustersRequestState)(state),
    scopes: state.scopes.userScopes
  };
}

var actionsToBind = {
  requestTopicClusters: _TopicClusters.requestTopics,
  setDynoAudience: DynoEditorAudienceActions.setAudience,
  addDynoAudienceGroup: DynoEditorAudienceActions.addGroup,
  addHideGroup: DynoEditorAudienceActions.addHideGroup,
  removeDynoAudienceGroup: DynoEditorAudienceActions.removeGroup,
  updateDynoAudienceGroup: DynoEditorAudienceActions.updateGroup,
  addFilter: DynoEditorAudienceActions.addFilter,
  removeFilter: DynoEditorAudienceActions.removeFilter,
  updateFilter: DynoEditorAudienceActions.updateFilter
};

var _default = (0, _reactRedux.connect)(mapStateToProps, actionsToBind)(AudienceTargetingContainer);

exports.default = _default;
module.exports = exports.default;